import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-markers',
    templateUrl: './markers.component.html',
    styleUrls: ['./markers.component.scss']
})
export class MarkersComponent {
    @Input() dynamicPortalUrlMarkerIsMandatory: boolean;
    @Input() dynamicAccessCodeMarkerIsMandatory: boolean;

    @Input() dynamicReasonsMarker: string;
    @Input() dynamicPortalUrlMarker: string;
    @Input() dynamicAccessCodeMarker: string;

    @Input() dynamicReasonsMarkerFound: boolean;
    @Input() dynamicPortalUrlMarkerFound: boolean;
    @Input() dynamicAccessCodeMarkerFound: boolean;
}